import { apiClient } from "../lib/api";

export const schedulingApi = {
  listTemplates: (activeOnly) => apiClient.get("/scheduling/templates", { params: { active_only: !!activeOnly } }),
  createTemplate: (payload) => apiClient.post("/scheduling/templates", payload),
  updateTemplate: (id, payload) => apiClient.patch(`/scheduling/templates/${id}`, payload),

  listStaffingPlans: (storeLocation, month) => apiClient.get("/scheduling/staffing-plans", { params: { store_location: storeLocation || undefined, month: month || undefined } }),
  upsertStaffingPlan: (payload) => apiClient.post("/scheduling/staffing-plans", payload),

  listSchedules: (storeLocation, status) => apiClient.get("/scheduling/schedules", { params: { store_location: storeLocation || undefined, status: status || undefined } }),
  createSchedule: (payload) => apiClient.post("/scheduling/schedules", payload),
  getSchedule: (id) => apiClient.get(`/scheduling/schedules/${id}`),
  listAssignments: (scheduleId) => apiClient.get(`/scheduling/schedules/${scheduleId}/assignments`),
  eligibilityBoard: (scheduleId) => apiClient.get(`/scheduling/schedules/${scheduleId}/eligibility-board`),
  coverage: (scheduleId) => apiClient.get(`/scheduling/schedules/${scheduleId}/coverage`),
  addAssignment: (scheduleId, payload) => apiClient.post(`/scheduling/schedules/${scheduleId}/assignments`, payload),
  addDoubleShift: (scheduleId, payload) => apiClient.post(`/scheduling/schedules/${scheduleId}/double-shift`, payload),
  removeAssignment: (assignmentId, reason) => apiClient.post(`/scheduling/assignments/${assignmentId}/remove`, { reason }),
  validateSchedule: (id) => apiClient.post(`/scheduling/schedules/${id}/validate`),
  submitForReview: (id) => apiClient.post(`/scheduling/schedules/${id}/submit-for-review`),
  approveSchedule: (id) => apiClient.post(`/scheduling/schedules/${id}/approve`),
  publishSchedule: (id) => apiClient.post(`/scheduling/schedules/${id}/publish`),
  createNewVersion: (id) => apiClient.post(`/scheduling/schedules/${id}/new-version`),

  addComment: (scheduleId, payload) => apiClient.post(`/scheduling/schedules/${scheduleId}/comments`, payload),
  listComments: (scheduleId) => apiClient.get(`/scheduling/schedules/${scheduleId}/comments`),
  acknowledgeSchedule: (scheduleId) => apiClient.post(`/scheduling/schedules/${scheduleId}/acknowledge`),
  mySchedule: () => apiClient.get("/scheduling/my-schedule"),
  myAcknowledgments: () => apiClient.get("/scheduling/my-acknowledgments"),
};

export const shiftSwapApi = {
  eligibleReplacements: (assignmentId) => apiClient.get("/scheduling/swaps/eligible-replacements", { params: { assignment_id: assignmentId } }),
  createRequest: (payload) => apiClient.post("/scheduling/swaps", payload),
  myRequests: () => apiClient.get("/scheduling/swaps/my"),
  respond: (requestId, accept) => apiClient.post(`/scheduling/swaps/${requestId}/respond`, { accept }),
  cancel: (requestId) => apiClient.post(`/scheduling/swaps/${requestId}/cancel`),

  listRequests: (storeLocation, status) => apiClient.get("/scheduling/swaps", { params: { store_location: storeLocation || undefined, status: status || undefined } }),
  getRequest: (requestId) => apiClient.get(`/scheduling/swaps/${requestId}`),
  decide: (requestId, approve, rejectionReason) => apiClient.post(`/scheduling/swaps/${requestId}/decide`, { approve, rejection_reason: rejectionReason || undefined }),
};
